export default __webpack_public_path__ + "static/Decentraland-cb97dfc984f5bf8590585b0161e6fbaa.png";